import { Grid, Tooltip } from "@mui/material";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import PullToRefresh from 'react-simple-pull-to-refresh';
import { LoadTemplates, LoadUsers } from '../../actions';
import { setHeaderTitle, setRefreshHandler } from "../../helpers/header.helper";
import { AddTemplateIcon, InfoCircleIcon, NewInfoCircleIcon } from "../../icon";
import { MediaModel, TemplateModel } from '../../models/templates.models';
import * as selector from "../../selectors/selectors";
import { AppRoutes } from "../routes/route.path";
import { appNote, buttonLabels, pageTitles } from "../shared/constants";
import PageHeaderComponent from "../shared/page-header.component";
import EditTemplate from './template-view.component';
import TemplatesComponent from "./templates.component";

interface IState {
    ShowTemplateForm: boolean;
    IsLoading: boolean;
    MobileMenu: boolean;
    SelectedRow?: TemplateModel;
    IsDeleted: boolean;
    SearchInput: string;
    OperatingRowId: string;
}

interface IProps { Media?: MediaModel }

const TemplateComponent = (props: IProps) => {
    const dispatch = useDispatch()
    const location = useLocation();
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const [ShowTemplateForm, setShowTemplateForm] = useState<boolean>(false)
    const [SelectedRow, setSelectedRow] = useState(undefined)
    const [gridApi, setGridApi] = useState(null);
    const [columnApi, setcolumnApi] = useState<any>(null)
    const [searchText, setSearchText] = useState<string>("");
    const [duplicateTemplate, SetDuplicateTemplate] = useState<boolean>(false);
    const Templates: TemplateModel[] = useSelector(selector.templates)

    useEffect(() => {
        if (Templates.length === 0) {
            LoadTemplates(dispatch);
            LoadUsers(dispatch);
        }
    }, [])

    const onGridReady = (params) => {
        setGridApi(params.api)
        setcolumnApi(params.columnApi)
    }


    const searchTemplate = (e: any) => {
        setSearchText(e.target.value);
        gridApi.setQuickFilter(e.target.value)
    }

    const addTemplate = (template?: TemplateModel) => {
        setShowTemplateForm(true)
        setSelectedRow(template)
    }

    const closeTemplate = (isConfirm: boolean) => {
        SetDuplicateTemplate(false)
        setShowTemplateForm(false)
        // if (!!isConfirm) {
        //     LoadTemplates(dispatch);
        // }
    };

    const editOptionHandler = (value?: TemplateModel) => {
        setShowTemplateForm(true)
        setSelectedRow(value)
    }

    const duplicateHandler = (value?: TemplateModel) => {
        SetDuplicateTemplate(true)
        setShowTemplateForm(true)
        setSelectedRow({
            ...value, ID: "",
        })
    }

    useEffect(() => {
        setHeaderTitle(pageTitles.TEMPLATES);
        setRefreshHandler(gridRefresh);
        if (searchText !== "") {
            gridApi.setQuickFilter(searchText);
        }
        return setHeaderTitle
    }, [gridApi, columnApi])

    const gridRefresh = () => {
        LoadTemplates(dispatch);
        if (!!columnApi) {
            columnApi.resetColumnState()
        }

        if (!!gridApi) {
            gridApi.refreshCells({ force: true })
        }
    }

    const pullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => LoadTemplates(dispatch))

    useEffect(() => {
        setSearchText("")
    }, [location.pathname])

    return (
        <>
            {IsMobileDevice && ShowTemplateForm ?
                <EditTemplate
                    CloseTemplate={closeTemplate}
                    Template={SelectedRow}
                    Show={ShowTemplateForm}
                    IsDuplicate={duplicateTemplate}
                />
                :
                <>
                    {IsMobileDevice
                        ?
                        <>
                            <PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh}>
                                <>
                                    <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
                                        <div className="">
                                            <PageHeaderComponent
                                                PlaceHolder={"Find a Template ..."}
                                                onSearch={searchTemplate}
                                                Actions={[{
                                                    OnClick: () => addTemplate(),
                                                    ButtonLabel: buttonLabels.ADD_NEW_TEMPLATE,
                                                    Variant: "primary-btn",
                                                }]} />
                                            <Grid item xs={12} className={"pt-1"}>
                                                <div className='d-flex w-p-100' >
                                                    <div className="w-p-25 t-align-center">
                                                        <Link className={` t-align-center py-1 mx-1 c-pointer h4-semibold  ${location.pathname === AppRoutes.TEMPLATES ? 'color-conv-hist-menu  h4-semibold' : 'color-conv-section-inactive'}`}
                                                            to={AppRoutes.TEMPLATES} >
                                                            {"Private"}
                                                        </Link>
                                                    </div>
                                                    <div className="w-p-40 t-align-center">
                                                        <Link className={` t-align-center py-1 mx-1 c-pointer h4-semibold  ${location.pathname === AppRoutes.TEMPLATES_PHONE_NUMBER ? 'color-conv-hist-menu  h4-semibold' : 'color-conv-section-inactive'}`}
                                                            to={AppRoutes.TEMPLATES_PHONE_NUMBER} >
                                                            {"Phone Line"}
                                                        </Link>
                                                    </div>
                                                    <div className="w-p-35 t-align-center">
                                                        <Link className={`t-align-center py-1 mx-1 c-pointer h4-semibold  ${location.pathname === AppRoutes.TEMPLATES_PUBLIC ? 'color-conv-hist-menu  h4-semibold' : 'color-conv-section-inactive'}`}
                                                            to={AppRoutes.TEMPLATES_PUBLIC}>
                                                            {"Organization"}
                                                        </Link>
                                                    </div>
                                                </div>
                                                <span className={`show-conversation-animation  show-conversation-border show-conversation-height bg-color-primary-light ${location.pathname === AppRoutes.TEMPLATES_PHONE_NUMBER ? "ml-p-49 w-p-50" : location.pathname === AppRoutes.TEMPLATES_PUBLIC ? "ml-p-99 w-p-50" : "ml-p-3 w-p-43"}`} />                                            </Grid>
                                        </div>
                                        <Grid item xs={12} className="h-p-100">
                                            <TemplatesComponent
                                                EditOptionHandler={editOptionHandler}
                                                DuplicateHandler={duplicateHandler}
                                                onGridReady={onGridReady}
                                                IsPrivate={location.pathname === AppRoutes.TEMPLATES ? true : false}
                                                IsPhoneNumberLevel={location.pathname === AppRoutes.TEMPLATES_PHONE_NUMBER ? true : false}
                                            />
                                            {/* <Routes>
                                                <Route
                                                    path={`${AppRoutes.TEMPLATES}/`}
                                                    Component={() => <TemplatesComponent
                                                        EditOptionHandler={editOptionHandler}
                                                        DuplicateHandler={duplicateHandler}
                                                        onGridReady={onGridReady}
                                                        Isprivate={true}
                                                    />} />
                                                <Route path={`${AppRoutes.TEMPLATES}/public`}
                                                    Component={() => <TemplatesComponent
                                                        EditOptionHandler={editOptionHandler}
                                                        DuplicateHandler={duplicateHandler}
                                                        onGridReady={onGridReady}
                                                        Isprivate={false}
                                                    />} />
                                            </Routes> */}
                                        </Grid>
                                    </div>
                                </>
                            </PullToRefresh>
                        </> :
                        <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
                            <PageHeaderComponent
                                PlaceHolder={"Find a Template ..."}
                                onSearch={searchTemplate}
                                Actions={[{
                                    OnClick: () => addTemplate(),
                                    ButtonLabel: buttonLabels.ADD_NEW_TEMPLATE,
                                    Variant: "primary-btn",
                                    Icon: AddTemplateIcon,
                                }]} />
                            <div className="d-flex justify-between w-p-100 px-2">
                                <div>
                                    <div className='d-flex'>
                                        <Link className={`${location.pathname === AppRoutes.TEMPLATES ? 'w-12 t-align-center py-1 c-pointer color-conv-hist-menu  h4-semibold' : 'w-12 t-align-center py-1 c-pointer color-conv-section-inactive h4-semibold'}`} to={AppRoutes.TEMPLATES}>
                                            {"Private"}
                                            <Tooltip title={appNote.TEMPLATES_RULES_ASSIGNED_PRIVATE} >
                                                <span style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '0.3rem', position: 'relative', top: '3px' }}>
                                                    <NewInfoCircleIcon />
                                                </span>
                                            </Tooltip>
                                        </Link>
                                        <Link className={`${location.pathname === AppRoutes.TEMPLATES_PHONE_NUMBER ? 'w-16 t-align-center py-1 c-pointer color-conv-hist-menu  h4-semibold' : 'w-16 t-align-center py-1 c-pointer color-conv-section-inactive h4-semibold'}`} to={AppRoutes.TEMPLATES_PHONE_NUMBER}>
                                            {"Phone Line"}
                                            <Tooltip title={appNote.TEMPLATES_RULES_PHONE_NUMBER}  >
                                                <span style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '0.3rem', position: 'relative', top: '3px' }}>
                                                    <NewInfoCircleIcon />
                                                </span>
                                            </Tooltip>
                                        </Link>
                                        <Link className={` ${location.pathname === AppRoutes.TEMPLATES_PUBLIC ? 'w-17 t-align-center py-1 c-pointer color-conv-hist-menu  h4-semibold' : 'w-17 t-align-center py-1 c-pointer h4-semibold color-conv-section-inactive'}`} to={AppRoutes.TEMPLATES_PUBLIC}>
                                            {"Organization"}
                                            <Tooltip title={appNote.TEMPLATES_ASSIGNED_GLOBAL}  >
                                                <span style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '0.3rem', position: 'relative', top: '3px' }}>
                                                    <NewInfoCircleIcon />
                                                </span>
                                            </Tooltip>
                                        </Link>
                                    </div>
                                    <div className={`show-conversation-animation show-conversation-border show-conversation-height bg-color-primary-light ${location.pathname === AppRoutes.TEMPLATES_PHONE_NUMBER ? "ml-12 w-15" : location.pathname === AppRoutes.TEMPLATES_PUBLIC ? "ml-28 w-16" : "ml-0 w-12"}`} />
                                </div>
                            </div>
                            <Grid item xs={12} className="h-p-100">
                                <TemplatesComponent
                                    EditOptionHandler={editOptionHandler}
                                    DuplicateHandler={duplicateHandler}
                                    onGridReady={onGridReady}
                                    IsPrivate={location.pathname.replace("/*", "") === AppRoutes.TEMPLATES ? true : false}
                                    IsPhoneNumberLevel={location.pathname === AppRoutes.TEMPLATES_PHONE_NUMBER ? true : false}
                                />
                                {/* <Routes>
                                    <Route
                                        path={`${AppRoutes.TEMPLATES}/`}
                                        Component={() => <TemplatesComponent
                                            EditOptionHandler={editOptionHandler}
                                            DuplicateHandler={duplicateHandler}
                                            onGridReady={onGridReady}
                                            Isprivate={true}
                                        />} />
                                    <Route path={`${AppRoutes.TEMPLATES}/public`}
                                        Component={() => <TemplatesComponent
                                            EditOptionHandler={editOptionHandler}
                                            DuplicateHandler={duplicateHandler}
                                            onGridReady={onGridReady}
                                            Isprivate={false}
                                        />} />
                                </Routes> */}
                            </Grid>
                        </div>
                    }
                    {
                        ShowTemplateForm &&
                        <EditTemplate
                            CloseTemplate={closeTemplate}
                            Template={SelectedRow}
                            Show={ShowTemplateForm}
                            IsDuplicate={duplicateTemplate}
                        />
                    }
                </>
            }
        </>
    )
}



export default TemplateComponent;
